// extracted by mini-css-extract-plugin
export default {"review-reply":"_1a1t1zq","reviewReply":"_1a1t1zq"};